// extracted by mini-css-extract-plugin
export var modalFooter = "_mi-0";